module.exports = __webpack_public_path__ + "img/icon4.4f29953d.png";